import { EndOfMatchesIcon, NoLongerActiveIcon, NoPendingMatchesIcon } from './styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getConnectUrlPath } from 'features/Connect/features/JobDiscovery/utils';
import { CandidatePortalDashboardViewsDataTestIds } from 'data-testids/CandidatePortalDataTestIds';
import { renewActiveJobSeekingStatus } from 'features/Connect/features/RenewJobSeekingStatus/utils';
import auth from 'utils/auth';
export const CandidatePortalRoutes = {
  MATCHES: '/candidate/matches',
  PROFILE: '/candidate/profile',
  MATCH_ARCHIVE: '/candidate/match-archive',
};

const jobboardReturnButtonText = 'Return to Job Board';

export const ViewState = {
  NO_PENDING_MATCHES: {
    primaryText: 'You have no pending matches',
    secondaryText: 'Check back soon for more!',
    icon: NoPendingMatchesIcon,
    buttonStartIcon: <ArrowBackIcon />,
    buttonText: jobboardReturnButtonText,
    buttonAction: (jobboardState: string) => {
      window.location.href = getConnectUrlPath(jobboardState);
    },
    showButtonSuccessSnackbar: false,
    requiresStateParam: true,
    dataTestId: CandidatePortalDashboardViewsDataTestIds.VIEW_STATE_NO_PENDING_MATCHES,
  },
  END_OF_MATCHES: {
    primaryText: "Congrats!\nYou've viewed all\nyour matches.",
    secondaryText: 'Check back soon\nfor more!',
    icon: EndOfMatchesIcon,
    buttonStartIcon: <ArrowBackIcon />,
    buttonText: jobboardReturnButtonText,
    buttonAction: (jobboardState: string) => {
      window.location.href = getConnectUrlPath(jobboardState);
    },
    showButtonSuccessSnackbar: false,
    requiresStateParam: true,
    dataTestId: CandidatePortalDashboardViewsDataTestIds.VIEW_STATE_END_OF_MATCHES,
  },
  NOT_OPEN_TO_MATCHES: {
    primaryText: "Uh-oh!\nLooks like you're not open to matching",
    secondaryText: 'Would you like to mark yourself as "open to matches" to see your matches?',
    icon: NoLongerActiveIcon,
    buttonText: 'Yes, activate me!',
    buttonAction: async (
      param?: string | ((status: { status: string; updated_at: string }) => void)
    ) => {
      const user = auth.getUser();
      if (user && typeof param === 'function') {
        await renewActiveJobSeekingStatus(user, param);
      }
    },
    showButtonSuccessSnackbar: true,
    requiresStateParam: false,
    dataTestId: CandidatePortalDashboardViewsDataTestIds.VIEW_STATE_NOT_OPEN_TO_MATCHES,
  },
};
